/* eslint-disable @typescript-eslint/no-explicit-any */ import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
/** @public */ export const localizationProviderInfoIdValidator = idValidator("localization_provider_info");
/** @public */ export function createLocalizationProviderInfoValidator(type, props, meta) {
    return T.object({
        id: localizationProviderInfoIdValidator,
        typeName: T.literal("localization_provider_info"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        sourceLanguage: T.object({
            locale: T.string,
            displayName: T.string,
            providerLanguageId: T.string,
            isRTL: T.boolean
        }),
        projectDisplayName: T.string,
        organizationId: T.number,
        internalLocalizationProviderId: T.number
    });
}
